<template>
  <div
    ref="cont"
    class="tabledrills position-relative text-noselect flex-1"
  >
    <div
      class="f-center"
      style="z-index: 4"
    >
      <div class="text-large f-center weight_700 mr-4">
        {{ $t('links.practice_drills') }}
      </div>
      <div
        class="gw_btn weight_500 text-medium csst csst_nm"
        style="--clr-back: var(--clr-primary); --radius: 4px 0 0 4px"
        data-tst="drills_table_new_drill"
        @click="openAdvancedFilter()"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        {{ $t('btn.new') }}

        <div
          class="csst_content clr-white"
          style="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
          v-html="$t('tooltips.new_drill')"
        ></div>
      </div>
      <div
        class="gw_btn weight_500 text-medium bl-clr csst csst_nm mr-auto"
        style="--clr-back: var(--clr-primary); --radius: 0 4px 4px 0; --b-clr: var(--clr-black-4)"
        @click="openImportDrillDialog()"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <i
          style="top: 0.025rem; position: relative"
          class="mdi text-normal mdi-tray-arrow-down line-height_1"
        ></i>
        <div
          class="csst_content text-nowrap"
          style="position: fixed"
        >
          {{ $t('common.import_drill') }}
        </div>
      </div>
    </div>

    <GwFilter
      v-if="!trulySelectedRows.length"
      class="mt-2"
      :asRow="true"
      :hasSaveBtn="false"
      :hasClearBtn="false"
      :allTags="allTags"
      filterUrlPrefix="ffdf"
      filterConfigKey="drillsFilter"
    />
    <TableDeleteBtns
      v-else
      class="mt-2"
      @confirm="deleteSelectedRows"
      @close="resetSelectedRows()"
    />

    <TableBody
      ref="tablebody"
      class="gw_table_small table-drills tbldrills flex-1 mt-2"
      :items="drills"
      :loading="apiCall.loading"
      :error="apiCall.error"
      :isInfiniteDynamic="true"
      :class="{ 'text-noselect': draggedItem }"
      style="
        --overflow-y-head: scroll;
        --overflow-y-body-scroller: scroll;
        --min-width-table-inner: 66rem;
      "
    >
      <template #head_before>
        <TableHead
          :sortConf="tbl_sortConf"
          :thead="thead"
          class="large-scroll-track"
          @click:th="tbl_handleSort"
        >
          <template #th_before>
            <TableHeadCell
              class="f-center gw_table_head_cell_sort_icon_visible"
              style="
                --overflow-th: none;
                --max-width-th: 6rem;
                --min-width-th: 6rem;
                --padding-th: 0;
                border-top-left-radius: 4px;
              "
            >
              <div
                class="d-flex"
                style="gap: 0.5rem"
              >
                <Checkbox
                  v-if="hasDragdrop"
                  class="csst csst_nm"
                  style="
                    --icon-size: 1.25rem;
                    --clr-disabled: var(--clr-grey-2);
                    --clr-enabled: var(--clr-primary);
                  "
                  :icons="['mdi-drag-vertical', 'mdi-drag-vertical']"
                  :value="tbl_sortConf.sortKey === 'ordering_position'"
                  @click="enableDrag"
                >
                  <template #content>
                    <div
                      class="csst_content clr-white"
                      style="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
                      v-html="$t('tooltips.drill_drag_drop_control')"
                    ></div>
                  </template>
                </Checkbox>
                <TableMainCheckbox
                  :indeterminate="mainCheckboxValue === 'indeterminate'"
                  :value="mainCheckboxValue === 'all'"
                  @click="toggleAll"
                />
                <TableFilterStar
                  :value="(filter.params || {}).favorite === 'true'"
                  @click="resetSelectedRows()"
                  @input="
                    val => $router.replace({ query: { ...$route.query, ffdf_favorite: val } })
                  "
                />
              </div>
            </TableHeadCell>
          </template>
        </TableHead>
      </template>
      <template #no_data>
        <div
          class="gw_box flex-1 f-center f-column anim-fade-in"
          style="--clr-box-back: var(--clr-black-0-3)"
        >
          <IconAndText
            v-if="filter.active && myDrills.length"
            icon="mdi-filter"
            :title="$t('data_table.practice_drills.no_data')"
            :subtitle="$t('data_table.practice_drills.no_data_change_filter_tra01')"
          />
          <IconAndText
            v-else
            icon="mdi-target"
            :title="$t('data_table.practice_drills.no_data')"
            :subtitle="$t('data_table.practice_drills.make_drill')"
          />
          <div
            v-if="!myDrills.length"
            class="gw_btn-v1 gw_btn_primary mt-4 clr-white"
            @click.stop="openAdvancedFilter()"
          >
            <i class="mdi mdi-plus text-semi-large mr-1"></i>
            {{ $t('common.create_drill') }}
          </div>
        </div>
      </template>

      <template #default="{ item, index }">
        <DrillsTableRow
          :namespace="namespace"
          :item="item"
          :index="index"
          :thead="thead"
          :draggedRows="draggedRows"
          :hasDragdrop="hasDragdrop"
          :dragDisabled="dragDisabled"
          :hasTagEdit="hasDragdrop"
          tagType="drills"
          :allTags="allTags"
          :myDrillsVisible="myDrillsVisible"
          :selected="selectedRows.some(i => (i ? i.id === item.id : false))"
          :data-tst="`drills_table_row_${index}`"
          @drag:start="e => handleDragstart({ e, item })"
          @click="toggleDetailOpen(item)"
          @toggle:selected="toggleSelected(item, index)"
          @click:tag_item="({ tag, tagItems }) => toggleTag([tag], tagItems, [item])"
          @toggle:favorite="toggleFavorite([item])"
          @click:tags="$refs => openTags($refs, [item])"
        >
        </DrillsTableRow>
        <DrillTableRowDetail
          v-if="openRows.some(i => (i ? i.id === item.id : false))"
          class="text-noselect"
          :namespace="namespace"
          :item="item"
        />
      </template>
    </TableBody>

    <DragDropHandler
      ref="dragdrophandler"
      :getIndicatorStyle="getIndicatorStyle"
      dropTargetIdPart="drills_table_row"
      @drag:drop="handleDragdrop"
    >
      <template #shallowitem>
        <div
          class="gw_box"
          style="--clr-box-back: var(--clr-primary)"
        >
          <div class="truncate">
            {{
              draggedRows.length > 1
                ? $t('common.xxx_selected_items', { num: draggedRows.length })
                : draggedItem
                  ? draggedItem.name
                  : ''
            }}
          </div>
        </div>
      </template>
    </DragDropHandler>
  </div>
</template>

<script>
import TableDeleteBtns from '@/components/DataTables/TableDeleteBtns'
import TableMainCheckbox from '@/components/DataTables/TableMainCheckbox'
import TableFilterStar from '@/components/DataTables/Filters/TableFilterStar'
import IconAndText from '@/components/Poker/Overlays/IconAndText'
import GwFilter from '@/components/DataTables/Filters/new/GwFilter'
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import TableHead from '@/components/DataTables/v2/TableHead'
import TableHeadCell from '@/components/DataTables/v2/TableHeadCell'
import TableBody from '@/components/DataTables/v2/TableBody'
import DrillsTableRow from '@/components/DataTables/v2/tables/DrillsTable/DrillsTableRow'
import DragDropHandler from '@/components/lib/DragDropHandler'
import DrillTableRowDetail from '@/components/DataTables/v2/tables/DrillsTable/DrillTableRowDetail'
import { getGameformatGroup } from '@/store/gameformat/gameformat'

import { toggleArrByKey } from '@/helpers/helpers'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'DrillTable',
  components: {
    TableHead,
    TableHeadCell,
    DrillTableRowDetail,
    TableBody,
    DrillsTableRow,
    DragDropHandler,
    TableDeleteBtns,
    TableMainCheckbox,
    TableFilterStar,
    IconAndText,
    GwFilter,
    Checkbox,
  },
  mixins: [table_mix, float_mix],
  data() {
    this.namespace = 'tmp/primary'
    return {
      tbl_sortConf: {
        sortKey: 'ordering_position',
        sortOrder: 'asc',
      },
      draggedItem: null,
      dropRow: { item: null, index: null, dropSurface: null },
      dropped: false,

      selectedRows: [],
      lastTouchedIdx: -1,
      openRows: [],
      tagItems: null,

      tagsReferenceEl: null,
      loadingGmf: false,
    }
  },
  created() {
    this.$store.dispatch('api_drills_get')
  },
  methods: {
    getIndicatorStyle(style) {
      if (!this.$refs.tablebody) return style
      const { width } = this.$refs.tablebody.$el.getBoundingClientRect()
      return {
        ...style,
        width: `${width}px`,
      }
    },
    enableDrag() {
      this.tbl_sortConf = {
        sortKey: 'ordering_position',
        sortOrder: 'asc',
      }
    },
    async openAdvancedFilter() {
      await this.$store.dispatch('gameformats_init_pageViewStores', { initPage: 'PracticeTrainer' })

      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query: this.$store.getters['tra/alpha/query_query'],
        push: false,
        replace: false,
        saveLocally: false,
      })

      this.$store.commit(`drills_reset`) // newDrill
      const dialog = `trainer-advanced-filter-dialog_namespace-${this.namespace}_tmpNamespace-${this.namespace}_newdrill`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    openImportDrillDialog() {
      const dialog = `import-drill-dialog_namespace-${this.namespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    toggleFavorite(items) {
      const favorite = items.every(i => i.favorite)
      this.$store.dispatch('drills_set_drill', {
        items: items.map(i => ({ ...i, favorite: !favorite })),
        hasMessage: false,
        method: 'PATCH',
        hasExpectedResponse: true,
      })
      this.resetSelectedRows()
    },
    toggleTag(tags, tagItems, items) {
      // TODO refactor drills table with tcrud_mixin helpers
      const someItemsHasTag = items.some(i => i.tags.some(t => tags.some(tt => t.id === tt.id)))
      const updatedItems = items.map(item => {
        let i_tags = item.tags.map(i => i.id || i)
        if (!tags.length) {
          i_tags = []
        } else if (someItemsHasTag) {
          i_tags = i_tags.filter(id => !tags.some(tt => id === tt.id))
        } else {
          i_tags = [...i_tags, ...tags.map(t => t.id)]
        }
        const res = {
          ...item,
          tags: i_tags,
        }
        return res
      })

      this.$store.dispatch('drills_set_drill', {
        items: updatedItems,
        hasMessage: false,
        method: 'PATCH',
        hasExpectedResponse: true,
      })
    },
    handleDragstart({ e, item }) {
      this.draggedItem = item
      if (this.$refs.dragdrophandler) {
        this.$refs.dragdrophandler.startDrag(e)
      }
    },
    handleDragdrop({ e, dropTarget, dropSurface }) {
      if (dropTarget && dropSurface) {
        const dropIdx = Number(dropTarget.id.replace('drills_table_row_', ''))
        const dropItem = this.drills[dropIdx]
        // debugger
        this.$store.dispatch('drills_handle_drop', {
          dropItem,
          dropSurface,
          draggedRows: this.draggedRows,
          drills: this.drills,
          sortOrder: this.tbl_sortConf.sortOrder,
        })
      }
      this.draggedItem = null
    },
    deleteSelectedRows() {
      this.$store.dispatch('drills_set_drill', {
        items: this.selectedRows,
        hasMessage: true,
        method: 'DELETE',
        namespace: this.namespace,
        hasExpectedResponse: true,
      })
      this.resetSelectedRows()
    },
    toggleDetailOpen(item) {
      this.openRows = toggleArrByKey({ arr: this.openRows, item, key: 'id', singleItem: true })
    },
    toggleSelected(item, index) {
      const res = !this.selectedRows.some(i => i?.id === item.id)
      const shiftKeyPressed = this.$store.getters.hotkey_pressed_bottom === 'Shift'

      this.selectedRows[index] = res ? item : null
      const lstIdx = this.lastTouchedIdx
      if (shiftKeyPressed && lstIdx !== index && this.drills[lstIdx]) {
        if (lstIdx < index) {
          this.selectedRows = this.drills.map((i, idx) =>
            idx >= lstIdx && idx <= index ? (res ? i : null) : this.selectedRows[idx],
          )
        } else {
          this.selectedRows = this.drills.map((i, idx) =>
            idx <= lstIdx && idx >= index ? (res ? i : null) : this.selectedRows[idx],
          )
        }
      }
      this.selectedRows = this.selectedRows.map(i => i)

      if (this.selectedRows.every(i => !i)) {
        this.lastTouchedIdx = -1
      } else {
        this.lastTouchedIdx = index
      }
    },
    toggleAll() {
      this.lastTouchedIdx = -1
      this.selectedRows =
        this.mainCheckboxValue === 'all' ? this.drills.map(i => null) : this.drills.map(i => i)
    },
    resetSelectedRows() {
      this.selectedRows = this.drills.map(i => null)
      this.lastTouchedIdx = -1
    },
  },
  computed: {
    draggedRows() {
      return this.draggedItem
        ? this.selectedRows.some(i => this.draggedItem.id === i?.id)
          ? this.selectedRows.filter(i => i)
          : [this.draggedItem]
        : []
    },
    dragDisabled() {
      return this.drills.length < 2 || this.tbl_sortConf.sortKey !== 'ordering_position'
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    thead() {
      const cols = {
        name: {
          name: this.$t('table_head.name'),
          sortKey: 'name',
          width: `26`,
        },
        tags: {
          name: this.$t('table_head.tags'),
          width: '27.5',
        },
        l_gmf_format: {
          name: this.$t('table_head.format'),
          sortKey: 'l_gmf_format',
          width: `8`,
        },
        total_hands: {
          name: this.$t('table_head.hands'),
          sortKey: 'total_hands',
          width: `8`,
        },
        gto_score_avg: {
          name: this.$t('table_head.gto_score'),
          sortKey: 'gto_score_avg',
          width: `8`,
        },
        // controls: {
        //   name: this.$t('table_head.controls'),
        //   cssClass: 'f-center',
        //   cssStyle: '--padding-th:0',
        //   width: `9.5`,
        // },
        // opener: {},
      }
      const res = {}
      Object.keys(cols).forEach(key => {
        const col = cols[key]
        const width = col.width || col.minWidth
        res[key] = {
          ...col,
          cssStyle: !width
            ? ''
            : `
            --min-width-th: ${width}rem;
            ${col.minWidth ? '' : `--max-width-th: ${width}rem`};
            `,
          tdStyle: !width
            ? ''
            : `
            --min-width-td: ${width}rem;
            ${col.minWidth ? '' : `--max-width-td: ${width}rem`};
            `,
        }
      })
      // console.log(res)
      return res
    },
    allTags() {
      let res = this.$store.getters.api_get_data('api_poker_drill_tags') || []
      res = this.myDrillsVisible ? res.filter(i => !i.public) : res.filter(i => i.public)
      return res
    },
    allDrills() {
      return this.$store.getters.drills_all
    },
    myDrills() {
      return this.allDrills.filter(i => !i.public)
    },
    publicDrills() {
      return this.allDrills.filter(i => i.public)
    },
    myDrillsVisible() {
      return !this.filterParams.drill_type?.includes('public_drills')
    },
    hasDragdrop() {
      return this.myDrillsVisible
    },
    drills() {
      // TODO find out why drills table render is slow (its not bad- more like weird - why?)
      if (this.apiCall.loading) {
        return []
      }
      let res = this.myDrillsVisible ? this.myDrills : this.publicDrills

      res = res.map(d => ({
        ...d,
        l_gmf_format:
          d.query.solution_type === 'custom'
            ? 'custom'
            : ((d.query.gametype && getGameformatGroup(d.query.gametype)) || '').toLowerCase(),
      }))

      const filter = this.filter?.filter || {}
      const filterKeys = Object.keys(filter).filter(
        key => !['drill_type', 'tags_anyall'].includes(key),
      )

      // console.log(filter)
      if (filterKeys.length) {
        res = res.filter(d => {
          const r = filterKeys.every(key => {
            if (key === 'favorite') {
              return filter[key].toString() === 'true' ? d.favorite : true
            }
            if (key === 'tags') {
              let filterTags = filter.tags
              filterTags = filterTags.filter(id => this.allTags.some(i => i.id === id))
              if (!filterTags.length) {
                return true
              }
              const drillTags = d.tags.map(i => i.id)
              if (!drillTags.length) {
                return false
              }
              if (filter.tags_anyall === 'all') {
                const rr = filterTags.every(id => drillTags.includes(id))
                return rr
              }
              const rr = filterTags.some(id => drillTags.includes(id))
              return rr
            }
            return !filter[key]?.length ? true : filter[key].includes(d[key])
          })
          return r
        })
      }

      const { sortKey, sortOrder } = this.tbl_sortConf

      if (['total_hands', 'gto_score_avg'].includes(sortKey)) {
        if (sortOrder === 'desc') {
          res.sort((a, b) => {
            // score vals -1 >> 1
            const aa = a.totals ? a.totals?.[sortKey] : -Infinity
            const bb = b.totals ? b.totals?.[sortKey] : -Infinity
            const r = aa > bb ? -1 : 1
            return r
          })
        } else {
          res.sort((a, b) => {
            const aa = a.totals ? a.totals?.[sortKey] : -Infinity
            const bb = b.totals ? b.totals?.[sortKey] : -Infinity
            const r = aa > bb ? 1 : -1
            return r
          })
        }
      } else if (sortOrder === 'desc') {
        res.sort((a, b) => (a?.[sortKey] > b?.[sortKey] ? -1 : 1))
      } else {
        res.sort((a, b) => (a?.[sortKey] > b?.[sortKey] ? 1 : -1))
      }

      // console.log(res)
      // res = [...res, ...res, ...res, ...res]
      // res = [...res, ...res, ...res, ...res]
      // res = [...res, ...res, ...res, ...res]
      // res = [...res, ...res, ...res, ...res]
      // res = res.map(i => ({ ...i, uid: uuid(), id: uuid() }))
      // console.log(res)
      return res
    },
    apiCall() {
      // return {
      // error: true,
      // status: 404,
      // loading: true,
      // }
      return this.$store.getters.api_get('api_poker_drills')
    },
    trulySelectedRows() {
      return this.selectedRows.filter(i => i)
    },
    filter() {
      return this.$store.getters.ffdf
    },
    filterParams() {
      return this.filter.params || {}
    },
    tcrud_params() {
      return {
        limit: this.tcrud_limit,
        offset: this.tcrud_offset,
      }
    },
    mainCheckboxValue() {
      const { length } = this.drills
      const selectedLength = this.trulySelectedRows.length
      if (!selectedLength) {
        return 'none'
      }
      if (selectedLength === length) {
        return 'all'
      }
      return 'indeterminate'
    },
  },
  watch: {
    drills() {
      this.resetSelectedRows()
    },
    hasDragdrop() {
      this.resetSelectedRows()
      if (this.hasDragdrop) {
        return
      }
      if (['ordering_position'].includes(this.tbl_sortConf.sortKey)) {
        this.tbl_sortConf.sortKey = 'l_gmf_format'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tabledrills {
  display: flex;
  min-height: 0;
  flex-direction: column;
  position: relative;
}
</style>
